export enum DesignOptions {
  text_input = "text_input",
  tabs = "tabs",
  nav_option = "nav_option",
}
